import { render } from "./AuthLayout.vue?vue&type=template&id=e472c516&scoped=true"
const script = {}

import "./AuthLayout.vue?vue&type=style&index=0&id=e472c516&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e472c516"]])

export default __exports__